export default "__VITE_ASSET__B03UTq1Y__"